// @ts-nocheck
import {
    getContentSearchCurrentTab,
    getContentSearchParameter,
} from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useContentSearchParameter = convertSelectorToHook(getContentSearchParameter);

export const useContentSearchCurrentTab = convertSelectorToHook(getContentSearchCurrentTab);
